var render = function render(){var _vm=this,_c=_vm._self._c;return _c('shoppable-instagram',_vm._b({},'shoppable-instagram',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }